import _toConsumableArray from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _regeneratorRuntime from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _createForOfIteratorHelper from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";
import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import { _ as e } from "../../chunks/tslib.es6.js";
import { symbolTypes as t } from "../../symbols.js";
import o from "../../core/Collection.js";
import "../../core/has.js";
import i from "../../core/Error.js";
import a from "../../core/Evented.js";
import r from "../../core/Handles.js";
import s from "../../core/Logger.js";
import { isSome as n, destroyMaybe as p, unwrap as l, abortMaybe as h, isNone as c, unwrapOr as d, get as u } from "../../core/maybe.js";
import { createAbortError as y, whenOrAbort as m } from "../../core/promiseUtils.js";
import { react as v } from "../../core/reactiveUtils.js";
import { watch as g, on as f, init as _, when as w, whenNotOnce as G, whenOnce as b } from "../../core/watchUtils.js";
import { property as T } from "../../core/accessorSupport/decorators/property.js";
import "../../core/arrayUtils.js";
import "../../core/accessorSupport/ensureType.js";
import { subclass as E } from "../../core/accessorSupport/decorators/subclass.js";
import { getReferenceEllipsoid as O } from "../../geometry/projectionEllipsoid.js";
import { geometryToCoordinates as S } from "../../geometry/support/coordsUtils.js";
import A from "../../layers/GraphicsLayer.js";
import { isDOMContainer as k } from "../../views/DOMContainer.js";
import { isSupportedGraphicResultMessage as C } from "../../views/3d/interactive/editingTools/isSupportedGraphicUtils.js";
import { isSupportedGraphic as H } from "../../views/3d/interactive/editingTools/moveGraphic/isSupportedGraphic.js";
import { isSupportedGraphic as I } from "../../views/3d/interactive/editingTools/reshapeGraphic/isSupportedGraphic.js";
import { isSupportedGraphic as M } from "../../views/3d/interactive/editingTools/transformGraphic/isSupportedGraphic.js";
import { addUniqueLayer as R } from "../../views/draw/support/layerUtils.js";
import { ViewEventPriorities as D } from "../../views/input/InputManager.js";
import { SKETCH_KEYS as U } from "../../views/interactive/keybindings.js";
import { SnappingManager as x } from "../../views/interactive/snapping/SnappingManager.js";
import P from "../../views/interactive/snapping/SnappingOptions.js";
import { createScreenPointFromEvent as j } from "../../views/support/screenUtils.js";
import { OperationHandle as L, UpdateOperationHandle as F } from "./support/OperationHandle.js";
import V from "../../symbols/SimpleMarkerSymbol.js";
import W from "../../symbols/SimpleFillSymbol.js";
import K from "../../symbols/SimpleLineSymbol.js";
var q = "esri.widgets.Sketch.SketchViewModel",
    Z = s.getLogger(q),
    z = {
  defaultZ: 0
},
    B = {
  reshapeOptions: {
    edgeOperation: "split",
    shapeOperation: "move",
    vertexOperation: "move"
  },
  enableMoveAllGraphics: !0,
  enableRotation: !0,
  enableScaling: !0,
  multipleSelectionEnabled: !0,
  preserveAspectRatio: !1,
  toggleToolOnClick: !0,
  enableZ: !0,
  tool: "transform"
};

var N = /*#__PURE__*/function (_a$EventedAccessor) {
  _inherits(N, _a$EventedAccessor);

  var _super = _createSuper(N);

  function N(e) {
    var _this;

    _classCallCheck(this, N);

    _this = _super.call(this, e), _this._numUpdating = 0, _this._handles = new r(), _this._internalGraphicsLayer = new A({
      listMode: "hide",
      internal: !0,
      title: "SVM Internal"
    }), _this._operationHandle = null, _this._viewHandles = new r(), _this.activeFillSymbol = null, _this.activeLineSymbol = null, _this.activeVertexSymbol = null, _this.allowDeleteKey = !0, _this.layer = null, _this.pointSymbol = new V({
      style: "circle",
      size: 6,
      color: [255, 255, 255],
      outline: {
        color: [50, 50, 50],
        width: 1
      }
    }), _this.polygonSymbol = new W({
      color: [150, 150, 150, .2],
      outline: {
        color: [50, 50, 50],
        width: 2
      }
    }), _this.polylineSymbol = new K({
      color: [130, 130, 130, 1],
      width: 2
    }), _this._snappingManager = null, _this.updateGraphics = new o(), _this.updateOnGraphicClick = !0, _this.updatePointSymbol = new V({
      size: 10,
      color: [0, 200, 255, .5],
      outline: {
        color: "black",
        width: 1
      }
    }), _this.updatePolygonSymbol = new W({
      color: [12, 207, 255, .2],
      outline: {
        join: "round",
        color: [12, 207, 255],
        width: 2
      }
    }), _this.updatePolylineSymbol = new K({
      color: [12, 207, 255],
      width: 2
    }), _this.vertexSymbol = new V({
      style: "circle",
      size: 6,
      color: [255, 255, 255],
      outline: {
        color: [50, 50, 50],
        width: 1
      }
    }), _this._moduleLoaderAbortController = null, _this._viewReadyAbortController = null, _this._originalAutoOpenEnabled = null, _this.defaultCreateOptions = z, _this.defaultUpdateOptions = B, _this.snappingOptions = new P();
    return _this;
  }

  _createClass(N, [{
    key: "initialize",
    value: function initialize() {
      var _this2 = this;

      this._handles.add([g(this, "layer", function () {
        _this2.cancel(), _this2._internalGraphicsLayer.elevationInfo = n(_this2.layer) ? _this2.layer.elevationInfo : null;
      }), f(this, "view.map.layers", "change", function (e) {
        e.removed.includes(_this2.layer) && _this2.cancel();
      }), f(this, "layer.graphics", "change", function (e) {
        if (n(_this2._operationHandle)) {
          var _iterator = _createForOfIteratorHelper(e.removed),
              _step;

          try {
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
              var _t = _step.value;
              _this2.updateGraphics.includes(_t) && (_this2.updateGraphics.length > 1 ? _this2._operationHandle.removeFromSelection(_t) : _this2._operationHandle.cancel());
            }
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }
        }
      }), _(this, "layer.elevationInfo", function () {
        _this2.cancel(), _this2._internalGraphicsLayer.elevationInfo = n(_this2.layer) ? _this2.layer.elevationInfo : null;
      }, !0), _(this, "view", function (e) {
        p(_this2._snappingManager), e && (_this2._snappingManager = new x({
          view: e,
          options: _this2.snappingOptions
        }), "2d" === e.type ? import("../../views/2d/interactive/editingTools.js") : "3d" === e.type && (import("../../views/3d/interactive/editingTools.js"), import("../../views/3d/layers/GraphicsLayerView3D.js")));
      }, !0)]);
    }
  }, {
    key: "destroy",
    value: function destroy() {
      this.cancel(), this._handles = p(this._handles), this._viewHandles = p(this._viewHandles), this._removeDefaultLayer(), this._snappingManager = p(this._snappingManager), this._set("view", null), this.emit("destroy");
    }
  }, {
    key: "_defaultUpdateTool",
    get: function get() {
      return "3d" === this.view.type ? "move" : "transform";
    }
  }, {
    key: "updating",
    get: function get() {
      return this._numUpdating > 0;
    }
  }, {
    key: "activeTool",
    get: function get() {
      return this._operationHandle && this._operationHandle.tool ? this._operationHandle.tool : null;
    }
  }, {
    key: "activeComponent",
    get: function get() {
      return this._operationHandle ? this._operationHandle.activeComponent : null;
    }
  }, {
    key: "createGraphic",
    get: function get() {
      return !n(this.activeComponent) || "draw-3d" !== this.activeComponent.type && "draw-2d" !== this.activeComponent.type ? this._get("createGraphic") : l(this.activeComponent.graphic);
    }
  }, {
    key: "defaultCreateOptions",
    set: function set(e) {
      this._set("defaultCreateOptions", _objectSpread(_objectSpread({}, z), e));
    }
  }, {
    key: "defaultUpdateOptions",
    set: function set(e) {
      this._set("defaultUpdateOptions", _objectSpread(_objectSpread(_objectSpread({}, B), e), {}, {
        reshapeOptions: _objectSpread(_objectSpread({}, B.reshapeOptions), null == e ? void 0 : e.reshapeOptions)
      }));
    }
  }, {
    key: "snappingOptions",
    set: function set(e) {
      n(this._snappingManager) && (this._snappingManager.options = e), this._set("snappingOptions", e);
    }
  }, {
    key: "state",
    get: function get() {
      var e;
      var t = !(null == (e = this.view) || !e.ready || !this.layer),
          o = this._operationHandle;
      return t && o ? "active" : t ? "ready" : "disabled";
    }
  }, {
    key: "view",
    get: function get() {
      return this._get("view");
    },
    set: function set(e) {
      var _this3 = this;

      var t = this._get("view");

      if (t) {
        var _e = t.container,
            _o = t.map;
        _e && (t.cursor = null), _o && _o.remove(this._internalGraphicsLayer), this._viewHandles.removeAll(), this.cancel();
      }

      var o = "view-ready";
      this._handles.remove(o), e && this._handles.add(w(e, "ready", function (t) {
        _this3._viewHandles.removeAll(), t && _this3._viewHandles.add(_this3._generateViewHandles(e));
      }, !0), o), this._set("view", e);
    }
  }, {
    key: "cancel",
    value: function cancel() {
      this._moduleLoaderAbortController = h(this._moduleLoaderAbortController), this._viewReadyAbortController = h(this._viewReadyAbortController), this._operationHandle && this._operationHandle.cancel();
    }
  }, {
    key: "complete",
    value: function complete() {
      this._operationHandle && this._operationHandle.complete();
    }
  }, {
    key: "delete",
    value: function _delete() {
      var e = this.state,
          t = this.updateGraphics;

      if ("active" === e && t.length) {
        var _e2 = this.activeTool,
            _o2 = this.layer,
            _i = t.toArray();

        _o2.removeMany(_i), this.cancel(), this._emitDeleteEvent({
          graphics: _i,
          tool: _e2
        });
      }
    }
  }, {
    key: "create",
    value: function () {
      var _create = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(e, t) {
        var _this4 = this;

        var o, i;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.cancel();
                _context.next = 3;
                return this._waitViewReady();

              case 3:
                if (!("disabled" === this.state)) {
                  _context.next = 5;
                  break;
                }

                throw this.layer || this._logError("sketch:missing-property", "Property 'layer' is missing on SketchViewModel."), this.view || this._logError("sketch:missing-property", "Property 'view' is missing on SketchViewModel."), y();

              case 5:
                if (!(n(this.view.activeTool) && (this.view.activeTool = null), !e)) {
                  _context.next = 7;
                  break;
                }

                return _context.abrupt("return", void this._logError("sketch:missing-parameter", "Missing parameter 'tool'."));

              case 7:
                R(this.view, this._internalGraphicsLayer);
                _context.next = 10;
                return this._setupCreateOperation(e, t);

              case 10:
                o = _context.sent;

                if (!(c(o) || this.destroyed)) {
                  _context.next = 13;
                  break;
                }

                return _context.abrupt("return", void this.view.map.remove(this._internalGraphicsLayer));

              case 13:
                i = function i() {
                  if (o === _this4._operationHandle) {
                    var _t2 = _this4.createGraphic,
                        _i2 = _this4._operationHandle.cancelled;
                    _this4._operationHandle.destroy(), _this4._operationHandle = null, _this4._set("createGraphic", null), _this4.view && _this4.view.map && _this4.view.map.remove(_this4._internalGraphicsLayer), o.cancelled || null == _t2 || _this4.layer.add(_t2), _this4.emit("create", {
                      graphic: _t2,
                      state: _i2 ? "cancel" : "complete",
                      tool: e,
                      toolEventInfo: null,
                      type: "create"
                    });
                  }
                };

                o.on("complete", i), this._operationHandle = o, this.view.ready && k(this.view) && this.view.focus();

              case 15:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function create(_x, _x2) {
        return _create.apply(this, arguments);
      }

      return create;
    }()
  }, {
    key: "update",
    value: function () {
      var _update = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(e, t) {
        var _this5 = this;

        var o, i, a, r, s;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                this.cancel();
                _context2.next = 3;
                return this._waitViewReady();

              case 3:
                o = this.layer, i = this.view, a = this.state;

                if (!("disabled" === a)) {
                  _context2.next = 6;
                  break;
                }

                throw i || this._logError("sketch:missing-property", "Property 'view' is missing on SketchViewModel."), o || this._logError("sketch:missing-property", "Property 'layer' is missing on SketchViewModel."), y();

              case 6:
                n(this.view.activeTool) && (this.view.activeTool = null);
                r = Array.isArray(e) ? e : [e];

                if (!(null == e || !r || !r.length)) {
                  _context2.next = 10;
                  break;
                }

                return _context2.abrupt("return", void this._logError("sketch:missing-parameter", "Missing parameter 'graphics'."));

              case 10:
                if (!r.some(function (e) {
                  return e.layer !== o ? (_this5._logError("sketch:invalid-parameter", "Parameter 'graphics' contains one or more graphics missing from the supplied GraphicsLayer."), !0) : c(e.geometry) ? (_this5._logError("sketch:invalid-parameter", "Parameter 'graphics' contains one or more graphics with an unsupported geometry."), !0) : "2d" === i.type && !i.spatialReference.equals(e.geometry.spatialReference) && (_this5._logError("sketch:invalid-parameter", "Parameter 'graphics' contains one or more graphics with a spatial reference different from the supplied MapView."), !0);
                })) {
                  _context2.next = 12;
                  break;
                }

                return _context2.abrupt("return");

              case 12:
                _context2.next = 14;
                return this._setupUpdateOperation(r, t);

              case 14:
                s = _context2.sent;
                this.destroyed || c(s) || ee(s) || (R(this.view, this._internalGraphicsLayer), this._setUpdateOperationHandle(s, t), this.emit("update", {
                  graphics: r,
                  state: "start",
                  aborted: !1,
                  tool: s.tool,
                  toolEventInfo: null,
                  type: "update"
                }));

              case 16:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function update(_x3, _x4) {
        return _update.apply(this, arguments);
      }

      return update;
    }()
  }, {
    key: "undo",
    value: function undo() {
      this.canUndo() && this._operationHandle.undo();
    }
  }, {
    key: "redo",
    value: function redo() {
      this.canRedo() && this._operationHandle.redo();
    }
  }, {
    key: "canUndo",
    value: function canUndo() {
      return !(!this._operationHandle || !this._operationHandle.canUndo());
    }
  }, {
    key: "canRedo",
    value: function canRedo() {
      return !(!this._operationHandle || !this._operationHandle.canRedo());
    }
  }, {
    key: "toggleUpdateTool",
    value: function toggleUpdateTool() {
      this._operationHandle && this._operationHandle.toggleTool && this._operationHandle.toggleTool();
    }
  }, {
    key: "_getFirstHit",
    value: function () {
      var _getFirstHit2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(e) {
        var t, _o3, _i3, _e3, _o4, _i4, _e4;

        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                t = [];
                _context3.t0 = this.view.type;
                _context3.next = _context3.t0 === "2d" ? 4 : _context3.t0 === "3d" ? 11 : 17;
                break;

              case 4:
                _o3 = [];
                this.view.map.allLayers.forEach(function (e) {
                  "vector-tile" !== e.type && "imagery" !== e.type || _o3.push(e);
                });
                _context3.next = 8;
                return this.view.hitTest(e, {
                  exclude: _o3
                });

              case 8:
                _i3 = _context3.sent;

                if (_i3.results.length > 0) {
                  _e3 = _i3.results[0];
                  _e3.graphic && t.push(_e3);
                }

                return _context3.abrupt("break", 17);

              case 11:
                _o4 = [this.view.map.ground];
                this.view.map.allLayers.forEach(function (e) {
                  "integrated-mesh" === e.type && _o4.push(e);
                });
                _context3.next = 15;
                return this.view.hitTest(e, {
                  exclude: _o4
                });

              case 15:
                _i4 = _context3.sent;

                if (_i4.results.length > 0) {
                  _e4 = _i4.results[0];
                  (!_i4.ground.mapPoint || this.view.map.ground.opacity < 1 || _i4.ground.distance - d(_e4.distance, 0) > -Math.min(3 * _i4.ground.distance, "global" === this.view.viewingMode ? O(this.view.renderCoordsHelper.spatialReference).radius / this.view.renderCoordsHelper.unitInMeters : Number.POSITIVE_INFINITY)) && t.push(_e4);
                }

              case 17:
                return _context3.abrupt("return", {
                  screenPoint: e,
                  results: t
                });

              case 18:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function _getFirstHit(_x5) {
        return _getFirstHit2.apply(this, arguments);
      }

      return _getFirstHit;
    }()
  }, {
    key: "_generateViewHandles",
    value: function _generateViewHandles(e) {
      var _this6 = this;

      return [e.on("immediate-click", /*#__PURE__*/function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(t) {
          var o, i, a, _iterator2, _step2, _r, _o5;

          return _regeneratorRuntime.wrap(function _callee4$(_context4) {
            while (1) {
              switch (_context4.prev = _context4.next) {
                case 0:
                  o = "active" === _this6.state && "create" === _this6._operationHandle.type;

                  if (!("disabled" === _this6.state || o || !_this6.updateOnGraphicClick)) {
                    _context4.next = 3;
                    break;
                  }

                  return _context4.abrupt("return");

                case 3:
                  _this6._beginAsyncOperation();

                  _context4.next = 6;
                  return t.async(function () {
                    return _this6._getFirstHit(j(t));
                  });

                case 6:
                  i = _context4.sent.results;
                  a = null;

                  if (!i.length) {
                    _context4.next = 32;
                    break;
                  }

                  _iterator2 = _createForOfIteratorHelper(i);
                  _context4.prev = 10;

                  _iterator2.s();

                case 12:
                  if ((_step2 = _iterator2.n()).done) {
                    _context4.next = 22;
                    break;
                  }

                  _r = _step2.value;

                  if (!_r.graphic) {
                    _context4.next = 20;
                    break;
                  }

                  _o5 = _r.graphic;

                  if (!(_this6.updateGraphics.includes(_o5) || _o5.layer === _this6.layer)) {
                    _context4.next = 19;
                    break;
                  }

                  t.stopPropagation(), a = _o5;
                  return _context4.abrupt("break", 22);

                case 19:
                  "2d" !== e.type || _this6._isComponentGraphic(_o5) || "active" !== _this6.state || _this6.cancel();

                case 20:
                  _context4.next = 12;
                  break;

                case 22:
                  _context4.next = 27;
                  break;

                case 24:
                  _context4.prev = 24;
                  _context4.t0 = _context4["catch"](10);

                  _iterator2.e(_context4.t0);

                case 27:
                  _context4.prev = 27;

                  _iterator2.f();

                  return _context4.finish(27);

                case 30:
                  _context4.next = 33;
                  break;

                case 32:
                  "active" === _this6.state && _this6.cancel();

                case 33:
                  _context4.t1 = n(a) && !_this6.updateGraphics.includes(a);

                  if (!_context4.t1) {
                    _context4.next = 37;
                    break;
                  }

                  _context4.next = 37;
                  return _this6.update([a], _objectSpread(_objectSpread({}, _this6.defaultUpdateOptions), {}, {
                    reshapeOptions: _objectSpread({}, _this6.defaultUpdateOptions.reshapeOptions)
                  }));

                case 37:
                  _this6._endAsyncOperation();

                case 38:
                case "end":
                  return _context4.stop();
              }
            }
          }, _callee4, null, [[10, 24, 27, 30]]);
        }));

        return function (_x6) {
          return _ref.apply(this, arguments);
        };
      }(), D.WIDGET)];
    }
  }, {
    key: "_setupCreateOperation",
    value: function () {
      var _setupCreateOperation2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(e, t) {
        var o, i;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                o = _objectSpread(_objectSpread({
                  hasZ: "3d" === this.view.type
                }, this.defaultCreateOptions), t);
                _context5.next = 3;
                return this._setupDrawGraphicTool(e, this.view, o);

              case 3:
                i = _context5.sent;
                return _context5.abrupt("return", c(i) ? null : (this.view.tools.add(i), this.view.activeTool = i, this._setupCreateOperationHandle(i)));

              case 5:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function _setupCreateOperation(_x7, _x8) {
        return _setupCreateOperation2.apply(this, arguments);
      }

      return _setupCreateOperation;
    }()
  }, {
    key: "_setupDrawGraphicTool",
    value: function () {
      var _setupDrawGraphicTool2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(e, t, o) {
        var i, a, r;
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                if (!("multipoint" === e && "3d" === t.type)) {
                  _context6.next = 2;
                  break;
                }

                return _context6.abrupt("return", (this._logError("sketch:create", "Multipoint geometries are not supported in SceneView"), null));

              case 2:
                i = "rectangle" !== e, a = "rectangle" !== e;
                this.snappingOptions.enabledToggled = !1;
                r = _objectSpread(_objectSpread({
                  view: t,
                  mode: "rectangle" === e || "circle" === e ? "hybrid" : "click"
                }, o), {}, {
                  snapToScene: !1,
                  geometryType: e,
                  graphicSymbol: this._getGraphicSymbolFromTool(e),
                  snappingManager: this._snappingManager,
                  forceUniformSize: a,
                  centered: i
                });
                return _context6.abrupt("return", "2d" === this.view.type ? this._makeDrawGraphicTool2D(r) : this._makeDrawGraphicTool3D(r));

              case 6:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function _setupDrawGraphicTool(_x9, _x10, _x11) {
        return _setupDrawGraphicTool2.apply(this, arguments);
      }

      return _setupDrawGraphicTool;
    }()
  }, {
    key: "_makeDrawGraphicTool2D",
    value: function () {
      var _makeDrawGraphicTool2D2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(e) {
        var t;
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.next = 2;
                return this._requireModule(import("../../views/2d/interactive/editingTools.js"));

              case 2:
                t = _context7.sent;
                return _context7.abrupt("return", ee(t) || this.destroyed ? null : new t.module.DrawGraphicTool2D(_objectSpread(_objectSpread({}, e), {}, {
                  activeVertexSymbol: this.activeVertexSymbol,
                  regularVerticesSymbol: this.vertexSymbol,
                  activeLineSymbol: this.activeLineSymbol,
                  activeFillSymbol: $(e.geometryType) ? this.activeFillSymbol : null
                })));

              case 4:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function _makeDrawGraphicTool2D(_x12) {
        return _makeDrawGraphicTool2D2.apply(this, arguments);
      }

      return _makeDrawGraphicTool2D;
    }()
  }, {
    key: "_makeDrawGraphicTool3D",
    value: function () {
      var _makeDrawGraphicTool3D2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(e) {
        var t;
        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _context8.next = 2;
                return this._requireModule(import("../../views/3d/interactive/editingTools.js"));

              case 2:
                t = _context8.sent;
                return _context8.abrupt("return", ee(t) || this.destroyed ? null : new t.module.DrawGraphicTool3D(_objectSpread(_objectSpread({}, e), {}, {
                  elevationInfo: this.layer.elevationInfo,
                  snapToScene: !n(this.layer.elevationInfo) || "absolute-height" === this.layer.elevationInfo.mode
                })));

              case 4:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));

      function _makeDrawGraphicTool3D(_x13) {
        return _makeDrawGraphicTool3D2.apply(this, arguments);
      }

      return _makeDrawGraphicTool3D;
    }()
  }, {
    key: "_setupCreateOperationHandle",
    value: function _setupCreateOperationHandle(e) {
      var _this7 = this;

      var t = null;
      var o = e.forceUniformSize,
          i = e.centered,
          a = [this.view.on("key-down", function (t) {
        if (t.key === U.pan) t.stopPropagation(), t.repeat || (e.enabled = !1);else if (t.key === U.complete) t.stopPropagation(), e.completeCreateOperation();else if (t.key !== U.vertexAdd || t.repeat) t.key === U.undo ? (t.stopPropagation(), r.undo()) : t.key === U.redo ? (t.stopPropagation(), r.redo()) : t.key !== U.snappingToggle || "rectangle" === e.geometryType || "circle" === e.geometryType || t.repeat ? t.key !== U.constraint || "rectangle" !== e.geometryType && "circle" !== e.geometryType || t.repeat ? t.key === U.center && (t.repeat || (e.centered = !i, t.stopPropagation())) : (e.forceUniformSize = !o, t.stopPropagation()) : (_this7.snappingOptions.enabledToggled = !0, t.stopPropagation());else {
          var _o6 = e.drawOperation.geometryType;
          "polyline" !== _o6 && "polygon" !== _o6 && "multipoint" !== _o6 || (t.stopPropagation(), e.drawOperation.commitStagedVertex());
        }
      }, D.WIDGET), this.view.on("key-up", function (t) {
        t.key === U.pan ? e.enabled = !0 : t.key === U.snappingToggle && "rectangle" !== e.geometryType && "circle" !== e.geometryType ? (_this7.snappingOptions.enabledToggled = !1, t.stopPropagation()) : t.key !== U.constraint || "rectangle" !== e.geometryType && "circle" !== e.geometryType ? t.key === U.center && (e.centered = i, t.stopPropagation()) : (e.forceUniformSize = o, t.stopPropagation());
      }, D.WIDGET), e.on("vertex-add", function (o) {
        switch (t = c(t) ? "start" : "active", o.operation) {
          case "apply":
            _this7.emit("create", {
              graphic: l(e.graphic),
              state: t,
              tool: _this7.activeTool,
              toolEventInfo: o,
              type: "create"
            });

            break;

          case "undo":
            _this7._emitUndoEvent({
              graphics: [l(e.graphic)],
              tool: e.geometryType
            });

            break;

          case "redo":
            _this7._emitRedoEvent({
              graphics: [l(e.graphic)],
              tool: e.geometryType
            });

        }
      }), e.on("cursor-update", function (t) {
        e.drawOperation.numCommittedVertices > 0 && _this7.emit("create", {
          graphic: l(e.graphic),
          state: "active",
          tool: _this7.activeTool,
          toolEventInfo: {
            coordinates: t.vertices[0].coordinates,
            type: "cursor-update"
          },
          type: "create"
        });
      }), e.on("vertex-remove", function (t) {
        switch (t.operation) {
          case "apply":
            _this7.emit("create", {
              graphic: l(e.graphic),
              state: "active",
              tool: _this7.activeTool,
              toolEventInfo: t,
              type: "create"
            });

            break;

          case "undo":
            _this7._emitUndoEvent({
              graphics: [l(e.graphic)],
              tool: e.geometryType
            });

            break;

          case "redo":
            _this7._emitRedoEvent({
              graphics: [l(e.graphic)],
              tool: e.geometryType
            });

        }
      }), e.on("complete", function (e) {
        _this7._set("createGraphic", l(e.graphic)), t = "complete", e.aborted ? r && r.cancel() : r && r.complete();
      }), v(function () {
        return _this7._getGraphicSymbolFromTool(e.geometryType);
      }, function (t) {
        e.graphicSymbol = t;
      })],
          r = new L({
        activeComponent: e,
        tool: e.geometryType,
        type: "create",
        onEnd: function onEnd() {
          var t;
          a.forEach(function (e) {
            return e.remove();
          }), a.length = 0, null == (t = _this7.view.tools) || t.remove(e), e.destroy();
        },
        undo: function undo() {
          e.canUndo && e.undo();
        },
        redo: function redo() {
          e.canRedo && e.redo();
        },
        canUndo: function canUndo() {
          return e.canUndo;
        },
        canRedo: function canRedo() {
          return e.canRedo;
        }
      });
      return r;
    }
  }, {
    key: "_getGraphicSymbolFromTool",
    value: function _getGraphicSymbolFromTool(e) {
      switch (e) {
        case "point":
        case "multipoint":
          return this.pointSymbol;

        case "polyline":
          return this.polylineSymbol;

        case "circle":
        case "rectangle":
        case "polygon":
          return this.polygonSymbol;

        default:
          return null;
      }
    }
  }, {
    key: "_setupUpdateOperation",
    value: function () {
      var _setupUpdateOperation2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9(e, t) {
        var o, i, a, r, _iterator3, _step3, _s, _t3, _t4, _t5;

        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                o = this.layer, i = this.view, a = _objectSpread(_objectSpread(_objectSpread({
                  tool: this._defaultUpdateTool
                }, this.defaultUpdateOptions), t), {}, {
                  reshapeOptions: _objectSpread(_objectSpread({}, this.defaultUpdateOptions.reshapeOptions), null == t ? void 0 : t.reshapeOptions)
                });
                r = a.tool;
                _iterator3 = _createForOfIteratorHelper(e);

                try {
                  for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
                    _s = _step3.value;
                    o.remove(_s), o.add(_s);
                  }
                } catch (err) {
                  _iterator3.e(err);
                } finally {
                  _iterator3.f();
                }

                if (!("3d" === i.type)) {
                  _context9.next = 16;
                  break;
                }

                if (!(0 === e.length)) {
                  _context9.next = 7;
                  break;
                }

                return _context9.abrupt("return", null);

              case 7:
                _context9.t0 = r;
                _context9.next = _context9.t0 === "move" ? 10 : _context9.t0 === "reshape" ? 11 : _context9.t0 === "transform" ? 15 : 16;
                break;

              case 10:
                return _context9.abrupt("return", this._setupMove3DOperation(e, a, i, r));

              case 11:
                if (!(e.length > 1)) {
                  _context9.next = 13;
                  break;
                }

                return _context9.abrupt("return", (this._logError("sketch:reshape-multiple", "Reshape operation does not support multiple graphics."), null));

              case 13:
                _t3 = I(e[0]);
                return _context9.abrupt("return", 0 === _t3 ? this._setupReshape3DOperation(e[0], a, i) : (this._logError("sketch:reshape", "Reshape operation not supported for provided graphic(s) (".concat(C(_t3), ").")), null));

              case 15:
                return _context9.abrupt("return", this._setupGraphicTransform3DOperation(e, a, i));

              case 16:
                _context9.t1 = r;
                _context9.next = _context9.t1 === "move" ? 19 : _context9.t1 === "reshape" ? 20 : _context9.t1 === "transform" ? 24 : 26;
                break;

              case 19:
                return _context9.abrupt("return", this._setupMoveOperation(e, a, i));

              case 20:
                if (!(e.length > 1)) {
                  _context9.next = 22;
                  break;
                }

                return _context9.abrupt("return", (this._logError("sketch:reshape-multiple", "Reshape operation does not support multiple graphics."), null));

              case 22:
                _t4 = I(e[0]);
                return _context9.abrupt("return", 0 === _t4 ? this._setupTransformOrReshapeOperation(e, r, a, i) : (this._logError("sketch:reshape", "Reshape operation not supported for provided graphic(s) (".concat(C(_t4), ").")), null));

              case 24:
                if (1 === e.length) {
                  _t5 = u(e[0].geometry, "type");
                  "point" !== _t5 && "multipoint" !== _t5 || (r = "reshape");
                }

                return _context9.abrupt("return", this._setupTransformOrReshapeOperation(e, r, a, i));

              case 26:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, this);
      }));

      function _setupUpdateOperation(_x14, _x15) {
        return _setupUpdateOperation2.apply(this, arguments);
      }

      return _setupUpdateOperation;
    }()
  }, {
    key: "_setupMove3DOperation",
    value: function () {
      var _setupMove3DOperation2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee11(e, t, o, i) {
        var _this8 = this;

        var a,
            _iterator4,
            _step4,
            _l,
            _e5,
            r,
            s,
            n,
            p,
            _args11 = arguments;

        return _regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                a = _args11.length > 4 && _args11[4] !== undefined ? _args11[4] : !1;
                _iterator4 = _createForOfIteratorHelper(e);
                _context11.prev = 2;

                _iterator4.s();

              case 4:
                if ((_step4 = _iterator4.n()).done) {
                  _context11.next = 11;
                  break;
                }

                _l = _step4.value;
                _e5 = H(_l);

                if (!(0 !== _e5)) {
                  _context11.next = 9;
                  break;
                }

                return _context11.abrupt("return", (this._logError("sketch:move", "Move operation not supported for provided graphic(s) (".concat(C(_e5), ").")), null));

              case 9:
                _context11.next = 4;
                break;

              case 11:
                _context11.next = 16;
                break;

              case 13:
                _context11.prev = 13;
                _context11.t0 = _context11["catch"](2);

                _iterator4.e(_context11.t0);

              case 16:
                _context11.prev = 16;

                _iterator4.f();

                return _context11.finish(16);

              case 19:
                _context11.next = 21;
                return this._requireModule(import("../../views/3d/interactive/editingTools.js"));

              case 21:
                r = _context11.sent;

                if (!ee(r)) {
                  _context11.next = 24;
                  break;
                }

                return _context11.abrupt("return", r);

              case 24:
                s = new r.module.GraphicMoveTool({
                  view: o,
                  enableZ: t.enableZ,
                  snappingManager: this._snappingManager
                });
                this.view.tools.add(s), s.graphics.addMany(e), a || this.updateGraphics.addMany(e);
                n = [], p = new F({
                  activeComponent: s,
                  tool: i,
                  type: "update",
                  onEnd: function onEnd() {
                    var e;
                    n.forEach(function (e) {
                      return e.remove();
                    }), n.length = 0, null == (e = _this8.view.tools) || e.remove(s), s.destroyed || s.destroy();
                  },
                  undo: function undo() {
                    Y(p, _this8.updateGraphics.toArray()), _this8._emitUndoEvent({
                      graphics: _this8.updateGraphics.toArray(),
                      tool: i
                    });
                  },
                  redo: function redo() {
                    J(p, _this8.updateGraphics.toArray()), _this8._emitRedoEvent({
                      graphics: _this8.updateGraphics.toArray(),
                      tool: i
                    });
                  },
                  addToSelection: function addToSelection(e) {
                    _this8.updateGraphics.push(e), s.graphics.push(e), _this8.emit("update", {
                      graphics: _this8.updateGraphics.toArray(),
                      state: "active",
                      aborted: !1,
                      tool: _this8.activeTool,
                      toolEventInfo: {
                        added: [e],
                        removed: [],
                        type: "selection-change"
                      },
                      type: "update"
                    });
                  },
                  removeFromSelection: function removeFromSelection(e) {
                    var t = _this8.updateGraphics.indexOf(e);

                    p.history.undo.forEach(function (e) {
                      return e.updates.splice(t, 1);
                    }), p.history.redo.forEach(function (e) {
                      return e.updates.splice(t, 1);
                    }), _this8.updateGraphics.remove(e), _this8.emit("update", {
                      graphics: _this8.updateGraphics.toArray(),
                      state: "active",
                      aborted: !1,
                      tool: _this8.activeTool,
                      toolEventInfo: {
                        added: [],
                        removed: [e],
                        type: "selection-change"
                      },
                      type: "update"
                    }), 0 !== _this8.updateGraphics.length ? s.graphics.remove(e) : p.complete();
                  },
                  toggleTool: function () {
                    var _toggleTool = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10() {
                      var e, a;
                      return _regeneratorRuntime.wrap(function _callee10$(_context10) {
                        while (1) {
                          switch (_context10.prev = _context10.next) {
                            case 0:
                              if (!(1 !== _this8.updateGraphics.length || !1 === t.toggleToolOnClick)) {
                                _context10.next = 2;
                                break;
                              }

                              return _context10.abrupt("return");

                            case 2:
                              if (!("transform" !== i)) {
                                _context10.next = 4;
                                break;
                              }

                              return _context10.abrupt("return");

                            case 4:
                              e = _this8.updateGraphics.getItemAt(0);

                              if (!(0 !== I(e))) {
                                _context10.next = 7;
                                break;
                              }

                              return _context10.abrupt("return");

                            case 7:
                              _context10.next = 9;
                              return _this8._setupReshape3DOperation(e, t, o, !0);

                            case 9:
                              a = _context10.sent;
                              ee(a) || (p.onEnd(), p.destroy(), _this8._setUpdateOperationHandle(a, t));

                            case 11:
                            case "end":
                              return _context10.stop();
                          }
                        }
                      }, _callee10);
                    }));

                    function toggleTool() {
                      return _toggleTool.apply(this, arguments);
                    }

                    return toggleTool;
                  }()
                });
                return _context11.abrupt("return", (n.push.apply(n, _toConsumableArray(this._getHandlesForComponent(p, t)).concat([this.view.on("immediate-click", function (e) {
                  return _this8._getCommonUpdateOperationClickHandlers(p, e, t);
                }, D.WIDGET), o.on("key-down", function (e) {
                  _this8._getCommonUpdateOperationKeyDownHandlers(p, e), e.key === U.snappingToggle && (_this8.snappingOptions.enabledToggled = !0, e.stopPropagation());
                }, D.WIDGET), o.on("key-up", function (e) {
                  e.key === U.snappingToggle && (_this8.snappingOptions.enabledToggled = !1, e.stopPropagation());
                }, D.WIDGET)])), p));

              case 28:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11, this, [[2, 13, 16, 19]]);
      }));

      function _setupMove3DOperation(_x16, _x17, _x18, _x19) {
        return _setupMove3DOperation2.apply(this, arguments);
      }

      return _setupMove3DOperation;
    }()
  }, {
    key: "_setupGraphicTransform3DOperation",
    value: function _setupGraphicTransform3DOperation(e, t, o) {
      var i = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : !1;

      if (1 === e.length && 0 === M(e[0])) {
        var _a = e[0],
            _r2 = _a.geometry;
        if (n(_r2) && ("point" === _r2.type || "mesh" === _r2.type)) return this._setupPointTransform3DOperation(_a, t, o);
        if (n(_r2) && ("polygon" === _r2.type || "polyline" === _r2.type)) return this._setupPolyTransform3DOperation(_a, t, o, i);
      }

      return this._setupMove3DOperation(e, t, o, "transform", i);
    }
  }, {
    key: "_setupPointTransform3DOperation",
    value: function () {
      var _setupPointTransform3DOperation2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee13(e, t, o) {
        var _this9 = this;

        var i, a, r, s, n, p, l, h;
        return _regeneratorRuntime.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                i = "transform";
                a = t.enableRotation;
                r = t.enableScaling;
                s = t.enableZ;
                _context13.next = 6;
                return this._requireModule(import("../../views/3d/interactive/editingTools.js"));

              case 6:
                n = _context13.sent;

                if (!ee(n)) {
                  _context13.next = 9;
                  break;
                }

                return _context13.abrupt("return", n);

              case 9:
                p = new n.module.GraphicTransformTool({
                  graphic: e,
                  view: o,
                  enableRotation: a,
                  enableScaling: r,
                  enableZ: s,
                  snappingManager: this._snappingManager
                });
                this.view.tools.add(p), this.updateGraphics.add(e);
                l = [], h = new F({
                  activeComponent: p,
                  tool: i,
                  type: "update",
                  onEnd: function onEnd() {
                    var e;
                    l.forEach(function (e) {
                      return e.remove();
                    }), l.length = 0, null == (e = _this9.view.tools) || e.remove(p), p.destroyed || p.destroy();
                  },
                  undo: function undo() {
                    Y(h, _this9.updateGraphics.toArray()), _this9._emitUndoEvent({
                      graphics: _this9.updateGraphics.toArray(),
                      tool: i
                    });
                  },
                  redo: function redo() {
                    J(h, _this9.updateGraphics.toArray()), _this9._emitRedoEvent({
                      graphics: _this9.updateGraphics.toArray(),
                      tool: i
                    });
                  },
                  addToSelection: function () {
                    var _addToSelection = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee12(e) {
                      var i;
                      return _regeneratorRuntime.wrap(function _callee12$(_context12) {
                        while (1) {
                          switch (_context12.prev = _context12.next) {
                            case 0:
                              _this9.updateGraphics.add(e), _this9.emit("update", {
                                graphics: _this9.updateGraphics.toArray(),
                                state: "active",
                                aborted: !1,
                                tool: _this9.activeTool,
                                toolEventInfo: {
                                  added: [e],
                                  removed: [],
                                  type: "selection-change"
                                },
                                type: "update"
                              });
                              _context12.next = 3;
                              return _this9._setupMove3DOperation(_this9.updateGraphics.toArray(), t, o, "transform", !0);

                            case 3:
                              i = _context12.sent;
                              ee(i) || (h.onEnd(), h.destroy(), _this9._setUpdateOperationHandle(i, t));

                            case 5:
                            case "end":
                              return _context12.stop();
                          }
                        }
                      }, _callee12);
                    }));

                    function addToSelection(_x23) {
                      return _addToSelection.apply(this, arguments);
                    }

                    return addToSelection;
                  }(),
                  removeFromSelection: function removeFromSelection(e) {
                    _this9.updateGraphics.remove(e), _this9.emit("update", {
                      graphics: _this9.updateGraphics.toArray(),
                      state: "active",
                      aborted: !1,
                      tool: _this9.activeTool,
                      toolEventInfo: {
                        added: [],
                        removed: [e],
                        type: "selection-change"
                      },
                      type: "update"
                    }), h.complete();
                  },
                  toggleTool: function toggleTool() {}
                });
                return _context13.abrupt("return", (l.push.apply(l, _toConsumableArray(this._getHandlesForComponent(h, t)).concat([this.view.on("immediate-click", function (e) {
                  return _this9._getCommonUpdateOperationClickHandlers(h, e, t);
                }, D.WIDGET), o.on("key-down", function (e) {
                  _this9._getCommonUpdateOperationKeyDownHandlers(h, e), e.key === U.snappingToggle && (_this9.snappingOptions.enabledToggled = !0, e.stopPropagation());
                }, D.WIDGET), o.on("key-up", function (e) {
                  e.key === U.snappingToggle && (_this9.snappingOptions.enabledToggled = !1, e.stopPropagation());
                }, D.WIDGET)])), h));

              case 13:
              case "end":
                return _context13.stop();
            }
          }
        }, _callee13, this);
      }));

      function _setupPointTransform3DOperation(_x20, _x21, _x22) {
        return _setupPointTransform3DOperation2.apply(this, arguments);
      }

      return _setupPointTransform3DOperation;
    }()
  }, {
    key: "_setupPolyTransform3DOperation",
    value: function () {
      var _setupPolyTransform3DOperation2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee16(e, t, o) {
        var _this10 = this;

        var i,
            a,
            r,
            s,
            n,
            p,
            l,
            h,
            c,
            d,
            _args16 = arguments;
        return _regeneratorRuntime.wrap(function _callee16$(_context16) {
          while (1) {
            switch (_context16.prev = _context16.next) {
              case 0:
                i = _args16.length > 3 && _args16[3] !== undefined ? _args16[3] : !1;
                a = "transform";
                r = t.enableRotation;
                s = t.enableScaling;
                n = t.enableZ;
                p = t.preserveAspectRatio;
                _context16.next = 8;
                return this._requireModule(import("../../views/3d/interactive/editingTools.js"));

              case 8:
                l = _context16.sent;

                if (!ee(l)) {
                  _context16.next = 11;
                  break;
                }

                return _context16.abrupt("return", l);

              case 11:
                h = new l.module.ExtentTransformTool({
                  graphic: e,
                  view: o,
                  enableRotation: r,
                  enableScaling: s,
                  enableZ: n,
                  preserveAspectRatio: p
                });
                this.view.tools.add(h), i || this.updateGraphics.add(e);
                c = [], d = new F({
                  activeComponent: h,
                  tool: a,
                  type: "update",
                  onEnd: function onEnd() {
                    var e;
                    c.forEach(function (e) {
                      return e.remove();
                    }), c.length = 0, null == (e = _this10.view.tools) || e.remove(h), h.destroyed || h.destroy();
                  },
                  canUndo: function canUndo() {
                    return h.canUndo;
                  },
                  undo: function undo() {
                    h.undo(), _this10._emitUndoEvent({
                      graphics: _this10.updateGraphics.toArray(),
                      tool: a
                    });
                  },
                  canRedo: function canRedo() {
                    return h.canRedo;
                  },
                  redo: function redo() {
                    h.redo(), _this10._emitRedoEvent({
                      graphics: _this10.updateGraphics.toArray(),
                      tool: a
                    });
                  },
                  addToSelection: function () {
                    var _addToSelection2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee14(e) {
                      var i;
                      return _regeneratorRuntime.wrap(function _callee14$(_context14) {
                        while (1) {
                          switch (_context14.prev = _context14.next) {
                            case 0:
                              _this10.updateGraphics.add(e), _this10.emit("update", {
                                graphics: _this10.updateGraphics.toArray(),
                                state: "active",
                                aborted: !1,
                                tool: _this10.activeTool,
                                toolEventInfo: {
                                  added: [e],
                                  removed: [],
                                  type: "selection-change"
                                },
                                type: "update"
                              });
                              _context14.next = 3;
                              return _this10._setupMove3DOperation(_this10.updateGraphics.toArray(), t, o, "transform", !0);

                            case 3:
                              i = _context14.sent;
                              ee(i) || (d.onEnd(), d.destroy(), _this10._setUpdateOperationHandle(i, t));

                            case 5:
                            case "end":
                              return _context14.stop();
                          }
                        }
                      }, _callee14);
                    }));

                    function addToSelection(_x27) {
                      return _addToSelection2.apply(this, arguments);
                    }

                    return addToSelection;
                  }(),
                  removeFromSelection: function removeFromSelection(e) {
                    _this10.updateGraphics.remove(e), _this10.emit("update", {
                      graphics: _this10.updateGraphics.toArray(),
                      state: "active",
                      aborted: !1,
                      tool: _this10.activeTool,
                      toolEventInfo: {
                        added: [],
                        removed: [e],
                        type: "selection-change"
                      },
                      type: "update"
                    }), d.complete();
                  },
                  toggleTool: function () {
                    var _toggleTool2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee15() {
                      var e, i;
                      return _regeneratorRuntime.wrap(function _callee15$(_context15) {
                        while (1) {
                          switch (_context15.prev = _context15.next) {
                            case 0:
                              if (!(1 !== _this10.updateGraphics.length || !1 === t.toggleToolOnClick)) {
                                _context15.next = 2;
                                break;
                              }

                              return _context15.abrupt("return");

                            case 2:
                              e = _this10.updateGraphics.getItemAt(0);

                              if (!(0 !== I(e))) {
                                _context15.next = 5;
                                break;
                              }

                              return _context15.abrupt("return");

                            case 5:
                              _context15.next = 7;
                              return _this10._setupReshape3DOperation(e, t, o, !0);

                            case 7:
                              i = _context15.sent;
                              ee(i) || (d.onEnd(), d.destroy(), _this10._setUpdateOperationHandle(i, t));

                            case 9:
                            case "end":
                              return _context15.stop();
                          }
                        }
                      }, _callee15);
                    }));

                    function toggleTool() {
                      return _toggleTool2.apply(this, arguments);
                    }

                    return toggleTool;
                  }()
                });
                return _context16.abrupt("return", (c.push.apply(c, _toConsumableArray(this._getHandlesForComponent(d, t)).concat([this.view.on("immediate-click", function (e) {
                  return _this10._getCommonUpdateOperationClickHandlers(d, e, t);
                }, D.WIDGET), this.view.on("key-down", function (e) {
                  return _this10._getCommonUpdateOperationKeyDownHandlers(d, e);
                }, D.WIDGET), this.view.on("key-down", function (e) {
                  e.key !== U.constraint || e.repeat || (h.preserveAspectRatio = !h.preserveAspectRatio, e.stopPropagation());
                }, D.WIDGET), this.view.on("key-up", function (e) {
                  e.key === U.constraint && (h.preserveAspectRatio = !h.preserveAspectRatio, e.stopPropagation());
                }, D.WIDGET)])), d));

              case 15:
              case "end":
                return _context16.stop();
            }
          }
        }, _callee16, this);
      }));

      function _setupPolyTransform3DOperation(_x24, _x25, _x26) {
        return _setupPolyTransform3DOperation2.apply(this, arguments);
      }

      return _setupPolyTransform3DOperation;
    }()
  }, {
    key: "_setupMoveOperation",
    value: function () {
      var _setupMoveOperation2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee17(e, t, o) {
        var _this11 = this;

        var i, a, r, s, n, p;
        return _regeneratorRuntime.wrap(function _callee17$(_context17) {
          while (1) {
            switch (_context17.prev = _context17.next) {
              case 0:
                i = "move";
                this.updateGraphics.addMany(e);
                _context17.next = 4;
                return this._getGraphicMover(e, t, o);

              case 4:
                a = _context17.sent;

                if (!ee(a)) {
                  _context17.next = 7;
                  break;
                }

                return _context17.abrupt("return", a);

              case 7:
                r = new F({
                  activeComponent: a,
                  tool: i,
                  type: "update",
                  onEnd: function onEnd() {
                    var e;
                    _this11._displayDefaultCursor(), p.forEach(function (e) {
                      return e.remove();
                    }), n.forEach(function (e) {
                      return e.remove();
                    }), p = [], n = [], a.destroy(), null == (e = _this11._internalGraphicsLayer) || e.removeMany(_toConsumableArray(_this11.updateGraphics.toArray()));
                  },
                  undo: function undo() {
                    var e = _this11.updateGraphics.toArray();

                    Y(r, e), r.refreshComponent(), _this11._emitUndoEvent({
                      graphics: e,
                      tool: i
                    });
                  },
                  redo: function redo() {
                    var e = _this11.updateGraphics.toArray();

                    J(r, e), r.refreshComponent(), _this11._emitRedoEvent({
                      graphics: e,
                      tool: i
                    });
                  },
                  addToSelection: function addToSelection(e) {
                    _this11.updateGraphics.push(e), a.graphics = _this11.updateGraphics.toArray(), _this11.emit("update", {
                      graphics: _this11.updateGraphics.toArray(),
                      state: "active",
                      aborted: !1,
                      tool: _this11.activeTool,
                      toolEventInfo: {
                        added: [e],
                        removed: [],
                        type: "selection-change"
                      },
                      type: "update"
                    });
                  },
                  removeFromSelection: function removeFromSelection(e) {
                    var t = _this11.updateGraphics.indexOf(e);

                    r.history.undo.forEach(function (e) {
                      return e.updates.splice(t, 1);
                    }), r.history.redo.forEach(function (e) {
                      return e.updates.splice(t, 1);
                    }), _this11.updateGraphics.remove(e);

                    var o = _this11.updateGraphics.toArray();

                    _this11.emit("update", {
                      graphics: o,
                      state: "active",
                      aborted: !1,
                      tool: _this11.activeTool,
                      toolEventInfo: {
                        added: [],
                        removed: [e],
                        type: "selection-change"
                      },
                      type: "update"
                    }), 0 !== _this11.updateGraphics.length ? a.graphics = o : r.complete();
                  }
                });
                s = !1, n = [o.on("immediate-click", function (e) {
                  return _this11._getCommonUpdateOperationClickHandlers(r, e, t);
                }, D.WIDGET), o.on("key-down", function (e) {
                  _this11._getCommonUpdateOperationKeyDownHandlers(r, e), e.key !== U.constraint || e.repeat || (s = !0, a.enableMoveAllGraphics = !a.enableMoveAllGraphics);
                }, D.WIDGET), o.on("key-up", function (e) {
                  e.key === U.constraint && s && (s = !1, a.enableMoveAllGraphics = !a.enableMoveAllGraphics);
                }, D.WIDGET)], p = this._getHandlesForComponent(r, t);
                return _context17.abrupt("return", r);

              case 10:
              case "end":
                return _context17.stop();
            }
          }
        }, _callee17, this);
      }));

      function _setupMoveOperation(_x28, _x29, _x30) {
        return _setupMoveOperation2.apply(this, arguments);
      }

      return _setupMoveOperation;
    }()
  }, {
    key: "_setupReshape3DOperation",
    value: function () {
      var _setupReshape3DOperation2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee20(e, t, o) {
        var _this12 = this;

        var i,
            a,
            r,
            s,
            n,
            p,
            _args20 = arguments;
        return _regeneratorRuntime.wrap(function _callee20$(_context20) {
          while (1) {
            switch (_context20.prev = _context20.next) {
              case 0:
                i = _args20.length > 3 && _args20[3] !== undefined ? _args20[3] : !1;
                a = "reshape";
                _context20.next = 4;
                return this._requireModule(import("../../views/3d/interactive/editingTools.js"));

              case 4:
                r = _context20.sent;

                if (!ee(r)) {
                  _context20.next = 7;
                  break;
                }

                return _context20.abrupt("return", r);

              case 7:
                this.snappingOptions.enabledToggled = !1;
                s = new r.module.GraphicReshapeTool({
                  view: o,
                  graphic: e,
                  enableZVertex: t.enableZ && "move" === t.reshapeOptions.vertexOperation,
                  enableZShape: t.enableZ && "move" === t.reshapeOptions.shapeOperation,
                  enableMoveGraphic: "move" === t.reshapeOptions.shapeOperation || "move-xy" === t.reshapeOptions.shapeOperation,
                  enableMidpoints: "split" === t.reshapeOptions.edgeOperation,
                  enableEdgeOffset: "offset" === t.reshapeOptions.edgeOperation,
                  snappingManager: this._snappingManager
                });
                o.tools.add(s), i || this.updateGraphics.add(e);
                n = [], p = new F({
                  activeComponent: s,
                  tool: a,
                  type: "update",
                  onEnd: function onEnd() {
                    var e;
                    n.forEach(function (e) {
                      return e.remove();
                    }), n.length = 0, null == (e = _this12.view.tools) || e.remove(s), s.destroyed || s.destroy();
                  },
                  canUndo: function canUndo() {
                    return s.canUndo;
                  },
                  undo: function undo() {
                    s.undo(), _this12._emitUndoEvent({
                      graphics: _this12.updateGraphics.toArray(),
                      tool: a
                    });
                  },
                  canRedo: function canRedo() {
                    return s.canRedo;
                  },
                  redo: function redo() {
                    s.redo(), _this12._emitRedoEvent({
                      graphics: _this12.updateGraphics.toArray(),
                      tool: a
                    });
                  },
                  addToSelection: function () {
                    var _addToSelection3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee18(e) {
                      var i;
                      return _regeneratorRuntime.wrap(function _callee18$(_context18) {
                        while (1) {
                          switch (_context18.prev = _context18.next) {
                            case 0:
                              _this12.updateGraphics.add(e), _this12.emit("update", {
                                graphics: _this12.updateGraphics.toArray(),
                                state: "active",
                                aborted: !1,
                                tool: _this12.activeTool,
                                toolEventInfo: {
                                  added: [e],
                                  removed: [],
                                  type: "selection-change"
                                },
                                type: "update"
                              });
                              _context18.next = 3;
                              return _this12._setupMove3DOperation(_this12.updateGraphics.toArray(), t, o, "transform", !0);

                            case 3:
                              i = _context18.sent;
                              ee(i) || (p.onEnd(), p.destroy(), _this12._setUpdateOperationHandle(i, t));

                            case 5:
                            case "end":
                              return _context18.stop();
                          }
                        }
                      }, _callee18);
                    }));

                    function addToSelection(_x34) {
                      return _addToSelection3.apply(this, arguments);
                    }

                    return addToSelection;
                  }(),
                  removeFromSelection: function removeFromSelection(e) {
                    _this12.updateGraphics.remove(e), _this12.emit("update", {
                      graphics: _this12.updateGraphics.toArray(),
                      state: "active",
                      aborted: !1,
                      tool: _this12.activeTool,
                      toolEventInfo: {
                        added: [],
                        removed: [e],
                        type: "selection-change"
                      },
                      type: "update"
                    }), p.complete();
                  },
                  toggleTool: function () {
                    var _toggleTool3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee19() {
                      var e;
                      return _regeneratorRuntime.wrap(function _callee19$(_context19) {
                        while (1) {
                          switch (_context19.prev = _context19.next) {
                            case 0:
                              if (!(!1 === t.toggleToolOnClick)) {
                                _context19.next = 2;
                                break;
                              }

                              return _context19.abrupt("return");

                            case 2:
                              _context19.next = 4;
                              return _this12._setupGraphicTransform3DOperation(_this12.updateGraphics.toArray(), t, o, !0);

                            case 4:
                              e = _context19.sent;
                              ee(e) || (p.onEnd(), p.destroy(), _this12._setUpdateOperationHandle(e, t));

                            case 6:
                            case "end":
                              return _context19.stop();
                          }
                        }
                      }, _callee19);
                    }));

                    function toggleTool() {
                      return _toggleTool3.apply(this, arguments);
                    }

                    return toggleTool;
                  }()
                });
                return _context20.abrupt("return", (n.push.apply(n, _toConsumableArray(this._getHandlesForComponent(p, t)).concat([o.on("immediate-click", function (e) {
                  return _this12._getCommonUpdateOperationClickHandlers(p, e, t);
                }, D.WIDGET), o.on("key-down", function (e) {
                  _this12._getCommonUpdateOperationKeyDownHandlers(p, e), e.key === U.snappingToggle && (_this12.snappingOptions.enabledToggled = !0, e.stopPropagation());
                }, D.WIDGET), o.on("key-up", function (e) {
                  e.key === U.snappingToggle && (_this12.snappingOptions.enabledToggled = !1, e.stopPropagation());
                }, D.WIDGET)])), p));

              case 12:
              case "end":
                return _context20.stop();
            }
          }
        }, _callee20, this);
      }));

      function _setupReshape3DOperation(_x31, _x32, _x33) {
        return _setupReshape3DOperation2.apply(this, arguments);
      }

      return _setupReshape3DOperation;
    }()
  }, {
    key: "_setupTransformOrReshapeOperation",
    value: function () {
      var _setupTransformOrReshapeOperation2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee25(e, t, o, i) {
        var _this13 = this;

        var a, r, s, p, l;
        return _regeneratorRuntime.wrap(function _callee25$(_context25) {
          while (1) {
            switch (_context25.prev = _context25.next) {
              case 0:
                a = o.multipleSelectionEnabled;
                this.updateGraphics.addMany(e);

                if (!("transform" === t)) {
                  _context25.next = 8;
                  break;
                }

                _context25.next = 5;
                return this._getBox(e, o, i);

              case 5:
                _context25.t0 = _context25.sent;
                _context25.next = 11;
                break;

              case 8:
                _context25.next = 10;
                return this._getReshape(e, o, i);

              case 10:
                _context25.t0 = _context25.sent;

              case 11:
                r = _context25.t0;

                if (!ee(r)) {
                  _context25.next = 14;
                  break;
                }

                return _context25.abrupt("return", r);

              case 14:
                s = new F({
                  activeComponent: r,
                  type: "update",
                  onEnd: function onEnd() {
                    l.forEach(function (e) {
                      return e.remove();
                    }), p.forEach(function (e) {
                      return e.remove();
                    }), l = [], p = [], s.activeComponent && !s.activeComponent.destroyed && s.activeComponent.destroy(), _this13._internalGraphicsLayer.removeMany(_this13.updateGraphics.toArray());
                  },
                  undo: function undo() {
                    Y(s, _this13.updateGraphics.toArray()), s.refreshComponent(), _this13._emitUndoEvent({
                      graphics: _this13.updateGraphics.toArray(),
                      tool: s.tool
                    });
                  },
                  redo: function redo() {
                    J(s, _this13.updateGraphics.toArray()), s.refreshComponent(), _this13._emitRedoEvent({
                      graphics: _this13.updateGraphics.toArray(),
                      tool: s.tool
                    });
                  },
                  addToSelection: function () {
                    var _addToSelection4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee21(e) {
                      var t, _t6, _a2;

                      return _regeneratorRuntime.wrap(function _callee21$(_context21) {
                        while (1) {
                          switch (_context21.prev = _context21.next) {
                            case 0:
                              t = s.activeComponent;

                              if (!("reshape" === t.type)) {
                                _context21.next = 12;
                                break;
                              }

                              _t6 = [].concat(_toConsumableArray(_this13.updateGraphics), [e]);

                              _this13.updateGraphics.removeAll();

                              _context21.next = 6;
                              return _this13._setupMoveOperation(_t6, o, i);

                            case 6:
                              _a2 = _context21.sent;

                              if (!ee(_a2)) {
                                _context21.next = 9;
                                break;
                              }

                              return _context21.abrupt("return");

                            case 9:
                              s.onEnd(), s.destroy(), _this13._setUpdateOperationHandle(_a2, o);
                              _context21.next = 13;
                              break;

                            case 12:
                              _this13.updateGraphics.add(e), t = t, t.graphics = _this13.updateGraphics.toArray(), t.refresh(), s.resetHistory();

                            case 13:
                              _this13.emit("update", {
                                graphics: _this13.updateGraphics.toArray(),
                                state: "active",
                                aborted: !1,
                                tool: _this13.activeTool,
                                toolEventInfo: {
                                  added: [e],
                                  removed: [],
                                  type: "selection-change"
                                },
                                type: "update"
                              });

                            case 14:
                            case "end":
                              return _context21.stop();
                          }
                        }
                      }, _callee21);
                    }));

                    function addToSelection(_x39) {
                      return _addToSelection4.apply(this, arguments);
                    }

                    return addToSelection;
                  }(),
                  removeFromSelection: function () {
                    var _removeFromSelection = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee22(e) {
                      var t, o, _e6;

                      return _regeneratorRuntime.wrap(function _callee22$(_context22) {
                        while (1) {
                          switch (_context22.prev = _context22.next) {
                            case 0:
                              t = _this13.updateGraphics.indexOf(e);
                              s.history.undo.forEach(function (e) {
                                return e.updates.splice(t, 1);
                              }), s.history.redo.forEach(function (e) {
                                return e.updates.splice(t, 1);
                              }), _this13.updateGraphics.remove(e);
                              o = _this13.updateGraphics.toArray();
                              if (0 === o.length) s.complete();else {
                                _e6 = o[0].geometry;
                                1 !== o.length || !n(_e6) || "point" !== _e6.type && "multipoint" !== _e6.type ? s.activeComponent.graphics = o : s.toggleTool();
                              }

                              _this13.emit("update", {
                                graphics: o,
                                state: "active",
                                aborted: !1,
                                tool: _this13.activeTool,
                                toolEventInfo: {
                                  added: [],
                                  removed: [e],
                                  type: "selection-change"
                                },
                                type: "update"
                              });

                            case 5:
                            case "end":
                              return _context22.stop();
                          }
                        }
                      }, _callee22);
                    }));

                    function removeFromSelection(_x40) {
                      return _removeFromSelection.apply(this, arguments);
                    }

                    return removeFromSelection;
                  }(),
                  toggleTool: function () {
                    var _toggleTool4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee23() {
                      var e, t, a;
                      return _regeneratorRuntime.wrap(function _callee23$(_context23) {
                        while (1) {
                          switch (_context23.prev = _context23.next) {
                            case 0:
                              if (!(_this13.updateGraphics.length > 1)) {
                                _context23.next = 2;
                                break;
                              }

                              return _context23.abrupt("return");

                            case 2:
                              e = _this13.updateGraphics.getItemAt(0), t = e.geometry;

                              if (!(n(t) && ("reshape" === s.tool && ("point" === t.type || "multipoint" === t.type) || "transform" === s.tool && "extent" === t.type))) {
                                _context23.next = 5;
                                break;
                              }

                              return _context23.abrupt("return");

                            case 5:
                              a = null;

                              if (!("transform" === s.tool)) {
                                _context23.next = 12;
                                break;
                              }

                              _context23.next = 9;
                              return _this13._getReshape([e], o, i);

                            case 9:
                              a = _context23.sent;
                              _context23.next = 17;
                              break;

                            case 12:
                              _context23.t0 = "reshape" === s.tool;

                              if (!_context23.t0) {
                                _context23.next = 17;
                                break;
                              }

                              _context23.next = 16;
                              return _this13._getBox([e], o, i);

                            case 16:
                              a = _context23.sent;

                            case 17:
                              ee(a) || (s.activeComponent.destroy(), s.activeComponent = a, s.activeComponent && (l.forEach(function (e) {
                                return e.remove();
                              }), l = _this13._getHandlesForComponent(s, o)));

                            case 18:
                            case "end":
                              return _context23.stop();
                          }
                        }
                      }, _callee23);
                    }));

                    function toggleTool() {
                      return _toggleTool4.apply(this, arguments);
                    }

                    return toggleTool;
                  }()
                });
                p = [i.on("immediate-click", /*#__PURE__*/function () {
                  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee24(e) {
                    var t, o;
                    return _regeneratorRuntime.wrap(function _callee24$(_context24) {
                      while (1) {
                        switch (_context24.prev = _context24.next) {
                          case 0:
                            _context24.next = 2;
                            return e.async(function () {
                              return _this13._getFirstHit(j(e));
                            });

                          case 2:
                            o = _context24.sent;
                            null != (t = o.results) && t.length ? o.results.some(function (t) {
                              if (t.graphic) {
                                var o;
                                var _i5 = t.graphic;
                                if (null != (o = e.native) && o.shiftKey && a) return e.stopPropagation(), s.addToSelection(_i5), !0;
                                if (_i5.layer === _this13.layer) return s.complete(), !0;
                              }

                              return !1;
                            }) : s.complete();

                          case 4:
                          case "end":
                            return _context24.stop();
                        }
                      }
                    }, _callee24);
                  }));

                  return function (_x41) {
                    return _ref2.apply(this, arguments);
                  };
                }(), D.WIDGET), i.on("key-down", function (e) {
                  if (_this13._getCommonUpdateOperationKeyDownHandlers(s, e), e.key !== U.snappingToggle || e.repeat || (_this13.snappingOptions.enabledToggled = !0, e.stopPropagation()), e.key === U.constraint && !e.repeat && s) {
                    var _e7 = s.activeComponent;
                    _e7 && "box" === _e7.type && (_e7.preserveAspectRatio = !_e7.preserveAspectRatio);
                  }
                }, D.WIDGET), i.on("key-up", function (e) {
                  var t;

                  if (e.key === U.snappingToggle && "reshape" === (null == s || null == (t = s.activeComponent) ? void 0 : t.type) && (_this13.snappingOptions.enabledToggled = !1, e.stopPropagation()), e.key === U.constraint && s) {
                    var _e8 = s.activeComponent;
                    _e8 && "box" === _e8.type && (_e8.preserveAspectRatio = !_e8.preserveAspectRatio);
                  }
                }, D.WIDGET)], l = this._getHandlesForComponent(s, o);
                return _context25.abrupt("return", s);

              case 17:
              case "end":
                return _context25.stop();
            }
          }
        }, _callee25, this);
      }));

      function _setupTransformOrReshapeOperation(_x35, _x36, _x37, _x38) {
        return _setupTransformOrReshapeOperation2.apply(this, arguments);
      }

      return _setupTransformOrReshapeOperation;
    }()
  }, {
    key: "_getGraphicMover",
    value: function () {
      var _getGraphicMover2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee26(e, t, o) {
        var _this14 = this;

        var i, a;
        return _regeneratorRuntime.wrap(function _callee26$(_context26) {
          while (1) {
            switch (_context26.prev = _context26.next) {
              case 0:
                i = t.enableMoveAllGraphics;
                _context26.next = 3;
                return this._requireModule(import("../../views/draw/support/GraphicMover.js"));

              case 3:
                a = _context26.sent;
                return _context26.abrupt("return", ee(a) ? a : new a.module.default({
                  enableMoveAllGraphics: i,
                  graphics: e,
                  view: o,
                  callbacks: {
                    onGraphicMoveStart: function onGraphicMoveStart(_ref3) {
                      var e = _ref3.dx,
                          t = _ref3.dy,
                          o = _ref3.graphic;
                      _this14._displayGrabbingCursor(), _this14.emit("update", {
                        graphics: _this14.updateGraphics.toArray(),
                        state: "active",
                        aborted: !1,
                        tool: _this14.activeTool,
                        toolEventInfo: {
                          dx: e,
                          dy: t,
                          mover: o,
                          type: "move-start"
                        },
                        type: "update"
                      });
                    },
                    onGraphicMove: function onGraphicMove(_ref4) {
                      var e = _ref4.dx,
                          t = _ref4.dy,
                          o = _ref4.graphic;
                      return _this14.emit("update", {
                        graphics: _this14.updateGraphics.toArray(),
                        state: "active",
                        aborted: !1,
                        tool: _this14.activeTool,
                        toolEventInfo: {
                          dx: e,
                          dy: t,
                          mover: o,
                          type: "move"
                        },
                        type: "update"
                      });
                    },
                    onGraphicMoveStop: function onGraphicMoveStop(_ref5) {
                      var e = _ref5.dx,
                          t = _ref5.dy,
                          o = _ref5.graphic;
                      _this14._displayPointerCursor(), _this14.emit("update", {
                        graphics: _this14.updateGraphics.toArray(),
                        state: "active",
                        aborted: !1,
                        tool: _this14.activeTool,
                        toolEventInfo: {
                          dx: e,
                          dy: t,
                          mover: o,
                          type: "move-stop"
                        },
                        type: "update"
                      });
                    },
                    onGraphicPointerOver: function onGraphicPointerOver() {
                      return _this14._displayPointerCursor();
                    },
                    onGraphicPointerOut: function onGraphicPointerOut() {
                      return _this14._displayDefaultCursor();
                    }
                  }
                }));

              case 5:
              case "end":
                return _context26.stop();
            }
          }
        }, _callee26, this);
      }));

      function _getGraphicMover(_x42, _x43, _x44) {
        return _getGraphicMover2.apply(this, arguments);
      }

      return _getGraphicMover;
    }()
  }, {
    key: "_getBox",
    value: function () {
      var _getBox2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee27(e, t, o) {
        var _this15 = this;

        var i, a, r, s;
        return _regeneratorRuntime.wrap(function _callee27$(_context27) {
          while (1) {
            switch (_context27.prev = _context27.next) {
              case 0:
                i = t.enableRotation;
                a = t.enableScaling;
                r = t.preserveAspectRatio;
                _context27.next = 5;
                return this._requireModule(import("../../views/draw/support/Box.js"));

              case 5:
                s = _context27.sent;
                return _context27.abrupt("return", ee(s) ? s : new s.module.default({
                  graphics: e,
                  enableRotation: i,
                  enableScaling: a,
                  preserveAspectRatio: r,
                  layer: this._internalGraphicsLayer,
                  view: o,
                  callbacks: {
                    onMoveStart: function onMoveStart(e) {
                      return _this15.emit("update", {
                        graphics: _this15.updateGraphics.toArray(),
                        state: "active",
                        aborted: !1,
                        tool: _this15.activeTool,
                        toolEventInfo: _objectSpread({}, e),
                        type: "update"
                      });
                    },
                    onMove: function onMove(e) {
                      return _this15.emit("update", {
                        graphics: _this15.updateGraphics.toArray(),
                        state: "active",
                        aborted: !1,
                        tool: _this15.activeTool,
                        toolEventInfo: _objectSpread({}, e),
                        type: "update"
                      });
                    },
                    onMoveStop: function onMoveStop(e) {
                      return _this15.emit("update", {
                        graphics: _this15.updateGraphics.toArray(),
                        state: "active",
                        aborted: !1,
                        tool: _this15.activeTool,
                        toolEventInfo: _objectSpread({}, e),
                        type: "update"
                      });
                    },
                    onScaleStart: function onScaleStart(e) {
                      return _this15.emit("update", {
                        graphics: _this15.updateGraphics.toArray(),
                        state: "active",
                        aborted: !1,
                        tool: _this15.activeTool,
                        toolEventInfo: _objectSpread({}, e),
                        type: "update"
                      });
                    },
                    onScale: function onScale(e) {
                      return _this15.emit("update", {
                        graphics: _this15.updateGraphics.toArray(),
                        state: "active",
                        aborted: !1,
                        tool: _this15.activeTool,
                        toolEventInfo: _objectSpread({}, e),
                        type: "update"
                      });
                    },
                    onScaleStop: function onScaleStop(e) {
                      return _this15.emit("update", {
                        graphics: _this15.updateGraphics.toArray(),
                        state: "active",
                        aborted: !1,
                        tool: _this15.activeTool,
                        toolEventInfo: _objectSpread({}, e),
                        type: "update"
                      });
                    },
                    onRotateStart: function onRotateStart(e) {
                      return _this15.emit("update", {
                        graphics: _this15.updateGraphics.toArray(),
                        state: "active",
                        aborted: !1,
                        tool: _this15.activeTool,
                        toolEventInfo: _objectSpread({}, e),
                        type: "update"
                      });
                    },
                    onRotate: function onRotate(e) {
                      return _this15.emit("update", {
                        graphics: _this15.updateGraphics.toArray(),
                        state: "active",
                        aborted: !1,
                        tool: _this15.activeTool,
                        toolEventInfo: _objectSpread({}, e),
                        type: "update"
                      });
                    },
                    onRotateStop: function onRotateStop(e) {
                      return _this15.emit("update", {
                        graphics: _this15.updateGraphics.toArray(),
                        state: "active",
                        aborted: !1,
                        tool: _this15.activeTool,
                        toolEventInfo: _objectSpread({}, e),
                        type: "update"
                      });
                    }
                  }
                }));

              case 7:
              case "end":
                return _context27.stop();
            }
          }
        }, _callee27, this);
      }));

      function _getBox(_x45, _x46, _x47) {
        return _getBox2.apply(this, arguments);
      }

      return _getBox;
    }()
  }, {
    key: "_getReshape",
    value: function () {
      var _getReshape2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee28(e, t, o) {
        var _this16 = this;

        var i, a, r, s, n;
        return _regeneratorRuntime.wrap(function _callee28$(_context28) {
          while (1) {
            switch (_context28.prev = _context28.next) {
              case 0:
                r = "split" === (null == (i = t.reshapeOptions) ? void 0 : i.edgeOperation);
                s = "move" === (null == (a = t.reshapeOptions) ? void 0 : a.shapeOperation);
                _context28.next = 4;
                return this._requireModule(import("../../views/draw/support/Reshape.js"));

              case 4:
                n = _context28.sent;
                return _context28.abrupt("return", ee(n) ? n : new n.module.default({
                  enableMidpoints: r,
                  enableMovement: s,
                  graphic: e[0],
                  layer: this._internalGraphicsLayer,
                  snappingManager: this._snappingManager,
                  view: o,
                  callbacks: {
                    onReshapeStart: function onReshapeStart(e) {
                      return _this16.emit("update", {
                        graphics: _this16.updateGraphics.toArray(),
                        state: "active",
                        aborted: !1,
                        tool: _this16.activeTool,
                        toolEventInfo: _objectSpread({}, e),
                        type: "update"
                      });
                    },
                    onReshape: function onReshape(e) {
                      return _this16.emit("update", {
                        graphics: _this16.updateGraphics.toArray(),
                        state: "active",
                        aborted: !1,
                        tool: _this16.activeTool,
                        toolEventInfo: _objectSpread({}, e),
                        type: "update"
                      });
                    },
                    onReshapeStop: function onReshapeStop(_ref6) {
                      var e = _ref6.mover,
                          t = _ref6.type;
                      return _this16.emit("update", {
                        graphics: _this16.updateGraphics.toArray(),
                        state: "active",
                        aborted: !1,
                        tool: _this16.activeTool,
                        toolEventInfo: {
                          mover: e,
                          type: t
                        },
                        type: "update"
                      });
                    },
                    onMoveStart: function onMoveStart(_ref7) {
                      var e = _ref7.dx,
                          t = _ref7.dy,
                          o = _ref7.mover,
                          i = _ref7.type;
                      return _this16.emit("update", {
                        graphics: _this16.updateGraphics.toArray(),
                        state: "active",
                        aborted: !1,
                        tool: _this16.activeTool,
                        toolEventInfo: {
                          dx: e,
                          dy: t,
                          mover: o,
                          type: i
                        },
                        type: "update"
                      });
                    },
                    onMove: function onMove(_ref8) {
                      var e = _ref8.dx,
                          t = _ref8.dy,
                          o = _ref8.mover,
                          i = _ref8.type;
                      return _this16.emit("update", {
                        graphics: _this16.updateGraphics.toArray(),
                        state: "active",
                        aborted: !1,
                        tool: _this16.activeTool,
                        toolEventInfo: {
                          dx: e,
                          dy: t,
                          mover: o,
                          type: i
                        },
                        type: "update"
                      });
                    },
                    onMoveStop: function onMoveStop(_ref9) {
                      var e = _ref9.dx,
                          t = _ref9.dy,
                          o = _ref9.mover,
                          i = _ref9.type;
                      return _this16.emit("update", {
                        graphics: _this16.updateGraphics.toArray(),
                        state: "active",
                        aborted: !1,
                        tool: _this16.activeTool,
                        toolEventInfo: {
                          dx: e,
                          dy: t,
                          mover: o,
                          type: i
                        },
                        type: "update"
                      });
                    },
                    onVertexAdd: function onVertexAdd(_ref10) {
                      var e = _ref10.added,
                          t = _ref10.type,
                          o = _ref10.vertices;
                      var i = e.map(function (e) {
                        return S(e.geometry);
                      });

                      _this16.emit("update", {
                        graphics: _this16.updateGraphics.toArray(),
                        state: "active",
                        aborted: !1,
                        tool: _this16.activeTool,
                        toolEventInfo: {
                          added: i,
                          vertices: o,
                          type: t
                        },
                        type: "update"
                      });
                    },
                    onVertexRemove: function onVertexRemove(_ref11) {
                      var e = _ref11.removed,
                          t = _ref11.type,
                          o = _ref11.vertices;
                      var i = e.map(function (e) {
                        return S(e.geometry);
                      });

                      _this16.emit("update", {
                        graphics: _this16.updateGraphics.toArray(),
                        state: "active",
                        aborted: !1,
                        tool: _this16.activeTool,
                        toolEventInfo: {
                          removed: i,
                          vertices: o,
                          type: t
                        },
                        type: "update"
                      });
                    }
                  }
                }));

              case 6:
              case "end":
                return _context28.stop();
            }
          }
        }, _callee28, this);
      }));

      function _getReshape(_x48, _x49, _x50) {
        return _getReshape2.apply(this, arguments);
      }

      return _getReshape;
    }()
  }, {
    key: "_getHandlesForComponent",
    value: function _getHandlesForComponent(e, t) {
      var _this17 = this;

      var o = e.activeComponent;

      switch (o.type) {
        case "graphic-mover":
          return [o.on("graphic-click", function (_ref12) {
            var t = _ref12.graphic,
                o = _ref12.viewEvent;
            var i;
            null != (i = o.native) && i.shiftKey && (o.stopPropagation(), e.removeFromSelection(t));
          }), o.on("graphic-move-start", function (t) {
            return e.addToHistory(X(t.allGraphics));
          })];

        case "box":
          return [o.on("graphic-click", function (o) {
            return _this17._onTransformOrReshape2DGraphicClick(e, t, o);
          }), o.on("move-start", function (t) {
            return e.addToHistory(X(t.graphics));
          }), o.on("rotate-start", function (t) {
            return e.addToHistory(X(t.graphics));
          }), o.on("scale-start", function (t) {
            return e.addToHistory(X(t.graphics));
          })];

        case "reshape":
          return [o.on("graphic-click", function (o) {
            return _this17._onTransformOrReshape2DGraphicClick(e, t, o);
          }), o.on("move-start", function (t) {
            return e.addToHistory(X([t.mover]));
          }), o.on("reshape-start", function (t) {
            return e.addToHistory(X([t.graphic]));
          }), o.on("vertex-add", function (t) {
            return e.addToHistory(X([t.oldGraphic]));
          }), o.on("vertex-remove", function (t) {
            return e.addToHistory(X([t.oldGraphic]));
          })];

        case "move-3d":
          return [o.on("graphic-move-start", function (t) {
            e.addToHistory(X(t.allGraphics)), _this17.emit("update", {
              graphics: _this17.updateGraphics.toArray(),
              state: "active",
              aborted: !1,
              tool: _this17.activeTool,
              toolEventInfo: {
                dx: 0,
                dy: 0,
                mover: t.allGraphics.length > 0 ? t.allGraphics[0] : null,
                type: "move-start"
              },
              type: "update"
            });
          }), o.on("graphic-move", function (e) {
            _this17.emit("update", {
              graphics: _this17.updateGraphics.toArray(),
              state: "active",
              aborted: !1,
              tool: _this17.activeTool,
              toolEventInfo: {
                dx: e.dx,
                dy: e.dy,
                mover: e.allGraphics.length > 0 ? e.allGraphics[0] : null,
                type: "move"
              },
              type: "update"
            });
          }), o.on("graphic-move-stop", function (e) {
            _this17.emit("update", {
              graphics: _this17.updateGraphics.toArray(),
              state: "active",
              aborted: !1,
              tool: _this17.activeTool,
              toolEventInfo: {
                dx: 0,
                dy: 0,
                mover: e.allGraphics.length > 0 ? e.allGraphics[0] : null,
                type: "move-stop"
              },
              type: "update"
            });
          }), o.on("immediate-click", function (o) {
            o.shiftKey ? _this17._toggleSelection([o.graphic], e, t) : e.toggleTool();
          })];

        case "transform-3d":
          return [o.on("record-undo", function (_ref13) {
            var t = _ref13.record;
            e.addToHistory({
              updates: [t]
            });
          }), o.on("graphic-translate-start", function (e) {
            _this17.emit("update", {
              graphics: _this17.updateGraphics.toArray(),
              state: "active",
              aborted: !1,
              tool: _this17.activeTool,
              toolEventInfo: {
                mover: e.graphic,
                dx: e.dxScreen,
                dy: e.dyScreen,
                type: "move-start"
              },
              type: "update"
            });
          }), o.on("graphic-translate-stop", function (e) {
            _this17.emit("update", {
              graphics: _this17.updateGraphics.toArray(),
              state: "active",
              aborted: !1,
              tool: _this17.activeTool,
              toolEventInfo: {
                mover: e.graphic,
                dx: e.dxScreen,
                dy: e.dyScreen,
                type: "move-stop"
              },
              type: "update"
            });
          }), o.on("graphic-rotate-start", function (e) {
            _this17.emit("update", {
              graphics: _this17.updateGraphics.toArray(),
              state: "active",
              aborted: !1,
              tool: _this17.activeTool,
              toolEventInfo: {
                mover: e.graphic,
                angle: e.angle,
                type: "rotate-start"
              },
              type: "update"
            });
          }), o.on("graphic-rotate-stop", function (e) {
            _this17.emit("update", {
              graphics: _this17.updateGraphics.toArray(),
              state: "active",
              aborted: !1,
              tool: _this17.activeTool,
              toolEventInfo: {
                mover: e.graphic,
                angle: e.angle,
                type: "rotate-stop"
              },
              type: "update"
            });
          }), o.on("graphic-scale-start", function (e) {
            _this17.emit("update", {
              graphics: _this17.updateGraphics.toArray(),
              state: "active",
              aborted: !1,
              tool: _this17.activeTool,
              toolEventInfo: {
                mover: e.graphic,
                xScale: e.xScale,
                yScale: e.yScale,
                type: "scale-start"
              },
              type: "update"
            });
          }), o.on("graphic-scale-stop", function (e) {
            _this17.emit("update", {
              graphics: _this17.updateGraphics.toArray(),
              state: "active",
              aborted: !1,
              tool: _this17.activeTool,
              toolEventInfo: {
                mover: e.graphic,
                xScale: e.xScale,
                yScale: e.yScale,
                type: "scale-stop"
              },
              type: "update"
            });
          }), o.on("graphic-translate", function (e) {
            _this17.emit("update", {
              graphics: _this17.updateGraphics.toArray(),
              state: "active",
              aborted: !1,
              tool: _this17.activeTool,
              toolEventInfo: {
                mover: e.graphic,
                dx: e.dxScreen,
                dy: e.dyScreen,
                type: "move"
              },
              type: "update"
            });
          }), o.on("graphic-rotate", function (e) {
            _this17.emit("update", {
              graphics: _this17.updateGraphics.toArray(),
              state: "active",
              aborted: !1,
              tool: _this17.activeTool,
              toolEventInfo: {
                mover: e.graphic,
                angle: e.angle,
                type: "rotate"
              },
              type: "update"
            });
          }), o.on("graphic-scale", function (e) {
            _this17.emit("update", {
              graphics: _this17.updateGraphics.toArray(),
              state: "active",
              aborted: !1,
              tool: _this17.activeTool,
              toolEventInfo: {
                mover: e.graphic,
                xScale: e.xScale,
                yScale: e.yScale,
                type: "scale"
              },
              type: "update"
            });
          }), o.on("immediate-click", function (o) {
            o.shiftKey ? _this17._toggleSelection([o.graphic], e, t) : e.toggleTool();
          })];

        case "reshape-3d":
          return [o.on("reshape", function (e) {
            _this17.emit("update", {
              graphics: _this17.updateGraphics.toArray(),
              state: "active",
              aborted: !1,
              tool: _this17.activeTool,
              toolEventInfo: e,
              type: "update"
            });
          }), o.on("move", function (e) {
            _this17.emit("update", {
              graphics: _this17.updateGraphics.toArray(),
              state: "active",
              aborted: !1,
              tool: _this17.activeTool,
              toolEventInfo: e,
              type: "update"
            });
          }), o.on("vertex-add", function (e) {
            _this17.emit("update", {
              graphics: _this17.updateGraphics.toArray(),
              state: "active",
              aborted: !1,
              tool: _this17.activeTool,
              toolEventInfo: e,
              type: "update"
            });
          }), o.on("vertex-remove", function (e) {
            _this17.emit("update", {
              graphics: _this17.updateGraphics.toArray(),
              state: "active",
              aborted: !1,
              tool: _this17.activeTool,
              toolEventInfo: e,
              type: "update"
            });
          }), o.on("immediate-click", function (o) {
            o.shiftKey ? _this17._toggleSelection([o.graphic], e, t) : e.toggleTool();
          })];

        default:
          return;
      }
    }
  }, {
    key: "_onTransformOrReshape2DGraphicClick",
    value: function _onTransformOrReshape2DGraphicClick(e, t, o) {
      var i;
      var a = o.graphic,
          r = o.viewEvent;
      return null != (i = r.native) && i.shiftKey && a.layer === this.layer ? (r.stopPropagation(), e.removeFromSelection(a)) : t.toggleToolOnClick ? (r.stopPropagation(), e.toggleTool()) : void 0;
    }
  }, {
    key: "_setUpdateOperationHandle",
    value: function _setUpdateOperationHandle(e, t) {
      var _this18 = this;

      this._operationHandle = e;
      var o = this.view.map;

      this._disablePopup(t);

      var i = function i() {
        if (e === _this18._operationHandle) {
          var _i6 = _this18.updateGraphics.toArray(),
              a = _this18._operationHandle.tool;

          _this18._operationHandle.destroy(), _this18._operationHandle = null, _this18._internalGraphicsLayer.removeMany(_this18.updateGraphics.toArray()), _this18.updateGraphics.removeAll(), o && o.remove(_this18._internalGraphicsLayer), _this18._restorePopup(t), _this18.emit("update", {
            graphics: _i6,
            state: "complete",
            aborted: e.cancelled,
            tool: a,
            toolEventInfo: null,
            type: "update"
          });
        }
      };

      e.on("complete", i);
    }
  }, {
    key: "_getCommonUpdateOperationClickHandlers",
    value: function () {
      var _getCommonUpdateOperationClickHandlers2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee29(e, t, o) {
        var _this19 = this;

        var i, a;
        return _regeneratorRuntime.wrap(function _callee29$(_context29) {
          while (1) {
            switch (_context29.prev = _context29.next) {
              case 0:
                i = j(t);
                _context29.next = 3;
                return t.async(function () {
                  return _this19._getFirstHit(i);
                });

              case 3:
                a = _context29.sent.results;

                if (a.length) {
                  _context29.next = 6;
                  break;
                }

                return _context29.abrupt("return", void e.complete());

              case 6:
                if (!(t.native.shiftKey && this._toggleSelection(a.map(function (e) {
                  return e.graphic;
                }), e, o))) {
                  _context29.next = 8;
                  break;
                }

                return _context29.abrupt("return", void t.stopPropagation());

              case 8:
                a.some(function (e) {
                  return e.graphic && _this19.updateGraphics.includes(e.graphic);
                }) ? t.stopPropagation() : e.complete();

              case 9:
              case "end":
                return _context29.stop();
            }
          }
        }, _callee29, this);
      }));

      function _getCommonUpdateOperationClickHandlers(_x51, _x52, _x53) {
        return _getCommonUpdateOperationClickHandlers2.apply(this, arguments);
      }

      return _getCommonUpdateOperationClickHandlers;
    }()
  }, {
    key: "_toggleSelection",
    value: function _toggleSelection(e, t, o) {
      var _this20 = this;

      var i = !!o.multipleSelectionEnabled;
      return e.some(function (e) {
        return null != e && !(!i || e.layer !== _this20.layer) && (_this20.updateGraphics.includes(e) ? t.removeFromSelection(e) : t.addToSelection(e), !0);
      });
    }
  }, {
    key: "_getCommonUpdateOperationKeyDownHandlers",
    value: function _getCommonUpdateOperationKeyDownHandlers(e, t) {
      if (!e) return;
      var o = t.key;
      o === U.undo && e.canUndo() ? (t.stopPropagation(), e.undo()) : o === U.redo && e.canRedo() ? (t.stopPropagation(), e.redo()) : o === U.cancel ? (t.stopPropagation(), e.cancel()) : this.allowDeleteKey && U.delete.includes(o) && this._onDeleteKey(t);
    }
  }, {
    key: "_onDeleteKey",
    value: function _onDeleteKey(e) {
      if (!this._operationHandle || "update" !== this._operationHandle.type) return;
      var t = this.activeComponent,
          o = this.updateGraphics.toArray();
      c(t) || "reshape-3d" === t.type || ("reshape" !== t.type || 1 === o.length && "point" === u(o[0].geometry, "type")) && (e.stopPropagation(), this.delete());
    }
  }, {
    key: "_removeDefaultLayer",
    value: function _removeDefaultLayer() {
      this._internalGraphicsLayer && (this.view && this.view.map && this.view.map.remove(this._internalGraphicsLayer), this._internalGraphicsLayer = p(this._internalGraphicsLayer));
    }
  }, {
    key: "_isComponentGraphic",
    value: function _isComponentGraphic(e) {
      var t = this.activeComponent;
      return !(!e || c(t)) && (e.attributes && e.attributes.esriSketchTool || "draw-2d" === t.type && t.graphic === e || ("box" === t.type || "reshape" === t.type) && t.isUIGraphic(e));
    }
  }, {
    key: "_displayPointerCursor",
    value: function _displayPointerCursor() {
      this.view && this.view.container && "pointer" !== this.view.cursor && (this.view.cursor = "pointer");
    }
  }, {
    key: "_displayGrabbingCursor",
    value: function _displayGrabbingCursor() {
      this.view && this.view.container && "grabbing" !== this.view.cursor && (this.view.cursor = "grabbing");
    }
  }, {
    key: "_displayDefaultCursor",
    value: function _displayDefaultCursor() {
      this.view && this.view.container && null !== this.view.cursor && (this.view.cursor = null);
    }
  }, {
    key: "_logError",
    value: function _logError(e, t, o) {
      Z.error(new i(e, t, o));
    }
  }, {
    key: "_requireModule",
    value: function () {
      var _requireModule2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee30(e) {
        var t, o;
        return _regeneratorRuntime.wrap(function _callee30$(_context30) {
          while (1) {
            switch (_context30.prev = _context30.next) {
              case 0:
                t = new AbortController();
                this._moduleLoaderAbortController = t;
                _context30.next = 4;
                return e;

              case 4:
                o = _context30.sent;
                return _context30.abrupt("return", this._moduleLoaderAbortController !== t || t.signal.aborted ? {
                  requireError: "aborted"
                } : {
                  module: o
                });

              case 6:
              case "end":
                return _context30.stop();
            }
          }
        }, _callee30, this);
      }));

      function _requireModule(_x54) {
        return _requireModule2.apply(this, arguments);
      }

      return _requireModule;
    }()
  }, {
    key: "_emitUndoEvent",
    value: function _emitUndoEvent(e) {
      this.emit("undo", _objectSpread(_objectSpread({}, e), {}, {
        type: "undo"
      }));
    }
  }, {
    key: "_emitRedoEvent",
    value: function _emitRedoEvent(e) {
      this.emit("redo", _objectSpread(_objectSpread({}, e), {}, {
        type: "redo"
      }));
    }
  }, {
    key: "_emitDeleteEvent",
    value: function _emitDeleteEvent(e) {
      this.emit("delete", _objectSpread(_objectSpread({}, e), {}, {
        type: "delete"
      }));
    }
  }, {
    key: "test",
    value: function test() {
      return {
        operationHandle: this._operationHandle,
        defaultUpdateOptions: B
      };
    }
  }, {
    key: "wait",
    value: function wait() {
      return G(this, "updating");
    }
  }, {
    key: "_beginAsyncOperation",
    value: function _beginAsyncOperation() {
      this._numUpdating += 1, this.notifyChange("updating");
    }
  }, {
    key: "_endAsyncOperation",
    value: function _endAsyncOperation() {
      this._numUpdating -= 1, this.notifyChange("updating");
    }
  }, {
    key: "_disablePopupEnabled",
    value: function _disablePopupEnabled(e) {
      var t;
      return "3d" !== (null == (t = this.view) ? void 0 : t.type) || this.updateOnGraphicClick || n(e) && e.toggleToolOnClick;
    }
  }, {
    key: "_disablePopup",
    value: function _disablePopup(e) {
      if (!this._disablePopupEnabled(e)) return;
      var t = this.view.popup;
      t && c(this._originalAutoOpenEnabled) && (this._originalAutoOpenEnabled = t.autoOpenEnabled, t.autoOpenEnabled = !1);
    }
  }, {
    key: "_restorePopup",
    value: function _restorePopup(e) {
      if (!this._disablePopupEnabled(e)) return;
      var t = this.view.popup;
      t && n(this._originalAutoOpenEnabled) && (t.autoOpenEnabled = this._originalAutoOpenEnabled, this._originalAutoOpenEnabled = null);
    }
  }, {
    key: "_waitViewReady",
    value: function () {
      var _waitViewReady2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee31() {
        return _regeneratorRuntime.wrap(function _callee31$(_context31) {
          while (1) {
            switch (_context31.prev = _context31.next) {
              case 0:
                _context31.t0 = this.view;

                if (!_context31.t0) {
                  _context31.next = 6;
                  break;
                }

                h(this._viewReadyAbortController);
                this._viewReadyAbortController = new AbortController();
                _context31.next = 6;
                return m(b(this.view, "ready"), this._viewReadyAbortController.signal);

              case 6:
              case "end":
                return _context31.stop();
            }
          }
        }, _callee31, this);
      }));

      function _waitViewReady() {
        return _waitViewReady2.apply(this, arguments);
      }

      return _waitViewReady;
    }()
  }]);

  return N;
}(a.EventedAccessor);

function $(e) {
  return "polygon" === e || "rectangle" === e || "circle" === e;
}

function Y(e, t) {
  Q("undo", e.history.undo, e.history.redo, t);
}

function J(e, t) {
  Q("redo", e.history.redo, e.history.undo, t);
}

function Q(e, t, o, i) {
  var a = t.pop().updates,
      r = [];
  i.forEach(function (t, o) {
    var i = a[o];
    null != i && ("geometry" in i && n(i.geometry) && (r.push({
      geometry: t.geometry
    }), t.geometry = i.geometry), "symbol" in i && n(i.symbol) && (r.push({
      symbol: t.symbol
    }), t.symbol = i.symbol), "undo" in i && (r.push(i), i[e](t)));
  }), o.push({
    updates: r
  });
}

function X(e) {
  return {
    updates: e.map(function (e) {
      return {
        geometry: e.geometry
      };
    })
  };
}

function ee(e) {
  return "requireError" in e && "aborted" === e.requireError;
}

e([T()], N.prototype, "updating", null), e([T()], N.prototype, "_operationHandle", void 0), e([T({
  readOnly: !0
})], N.prototype, "activeTool", null), e([T()], N.prototype, "activeFillSymbol", void 0), e([T()], N.prototype, "activeLineSymbol", void 0), e([T()], N.prototype, "activeVertexSymbol", void 0), e([T()], N.prototype, "allowDeleteKey", void 0), e([T({
  readOnly: !0
})], N.prototype, "createGraphic", null), e([T()], N.prototype, "defaultCreateOptions", null), e([T()], N.prototype, "defaultUpdateOptions", null), e([T()], N.prototype, "layer", void 0), e([T({
  types: t
})], N.prototype, "pointSymbol", void 0), e([T({
  types: t
})], N.prototype, "polygonSymbol", void 0), e([T({
  types: t
})], N.prototype, "polylineSymbol", void 0), e([T({
  type: P,
  nonNullable: !0
})], N.prototype, "snappingOptions", null), e([T()], N.prototype, "_snappingManager", void 0), e([T({
  readOnly: !0
})], N.prototype, "state", null), e([T({
  readOnly: !0
})], N.prototype, "updateGraphics", void 0), e([T()], N.prototype, "updateOnGraphicClick", void 0), e([T({
  types: t
})], N.prototype, "updatePointSymbol", void 0), e([T({
  types: t
})], N.prototype, "updatePolygonSymbol", void 0), e([T({
  types: t
})], N.prototype, "updatePolylineSymbol", void 0), e([T({
  types: t
})], N.prototype, "vertexSymbol", void 0), e([T({
  value: null
})], N.prototype, "view", null), e([T()], N.prototype, "cancel", null), e([T()], N.prototype, "complete", null), e([T()], N.prototype, "delete", null), e([T()], N.prototype, "create", null), e([T()], N.prototype, "update", null), e([T()], N.prototype, "undo", null), e([T()], N.prototype, "redo", null), e([T()], N.prototype, "canUndo", null), e([T()], N.prototype, "canRedo", null), e([T()], N.prototype, "toggleUpdateTool", null), N = e([E(q)], N);
var te = N;
export { te as default };